var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('exam-management-header'),_c('exam-management-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }